module.exports = __webpack_public_path__ + "img/1569279148.3555db44.jpg";